import "./SingleBlogPostTemplate.module.css"
import ToppmenyOchKontakt from "@/reusable_sections/Header"
import SingleBlogPostTemplateSection from "./sections/SingleBlogPostTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SingleBlogPostTemplatePage() {

  return (
    <div>
      <ToppmenyOchKontakt />
      <SingleBlogPostTemplateSection />
      <Footer />
    </div>
  )
}
